module.exports = __webpack_public_path__ + "static/susieyy-1a30f269bfafd9ccda90a2a3506456e4.png";